import Translation from 'app/shared/components/Translation/Translation';
import { WrittenBySt } from 'app/shared/components/ModelReview/WrittenBy/WrittenBy.css';

export const WrittenBy = () => {
  return (
    <WrittenBySt>
      <Translation
        id="shared.components.reviews.writtenBy"
        defaultMessage="Written by heycar"
      />
    </WrittenBySt>
  );
};
